export default __webpack_public_path__ + "FinPress.b129ee6b.png";